export const isString = val => typeof val === 'string'
export const isObject = val => val !== null && typeof val === 'object'
export const isNullObject = val => Object.keys(val).length === 0
export const isArray = val =>
  Object.prototype.toString.call(val) === '[object Array]'
export const isDef = val => val !== undefined && val !== null
export const isUndef = val => val === undefined || val === null

export function isNumeric(val) {
  return /^\d+(\.\d+)?$/.test(val)
}

export function isNaN(val) {
  if (Number.isNaN) {
    return Number.isNaN(val)
  }

  // eslint-disable-next-line no-self-compare
  return val !== val
}

/**
 * 修复ios设备上键盘的部分问题
 * 1. 键盘收起时，下方留白的问题
 * 2. 键盘被遮挡
 * @param {Element} [el]
 */
export function fixIosKeyboard(el) {
  const bodyElm = document.body

  // let scrollHeight = window.innerHeight

  // bodyElm.addEventListener('focusin', () => {
  //   console.info('focusin')
  //   clearTimeout(timer)
  //   timer = null
  //
  //   setTimeout(() => {
  //     window.scrollTo(0, scrollHeight)
  //   }, 50)
  // })

  bodyElm.addEventListener('focusout', () => {
    // 软键盘关闭事件, 修复键盘收起后键盘下方留白
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 200)
  })
}

/**
 * 修复安卓设备上收起键盘时未自动失去焦点的问题
 * @param {String|Array<String|Element>|Element} el 需要自动失去焦点的元素
 */
export function fixAndroidKeyboardAutoBlur(el) {
  const clientHeight =
    document.documentElement.clientHeight || document.body.clientHeight

  const _blur = _el => {
    if (isString(_el)) {
      document.querySelector(_el).blur()
    } else {
      _el.blur()
    }
  }

  // 监听安卓键盘收起事件
  window.onresize = () => {
    const resizeHeight =
      document.documentElement.clientHeight || document.body.clientHeight
    // 防止用户点击键盘中的收起按钮，输入框未失去焦点的问题
    if (resizeHeight === clientHeight) {
      if (isArray(el)) {
        el.forEach(_blur)
      } else {
        _blur(el)
      }
    }
  }
}

export function formatBigNumber(val, base = 1) {
  if (val === undefined) {
    return '--'
  }

  if (typeof val !== 'number') {
    return val
  }

  val = val * base
  let res
  const absVal = Math.abs(val)
  switch (true) {
    case absVal >= 1e8:
      res = Math.round(val / 1e6) / 100 + '亿'
      break
    case absVal >= 1e6:
      res = Math.round(val / 1e3) / 10 + '万'
      break
    case absVal >= 1e4:
      res = Math.round(val / 100) / 100 + '万'
      break
    default:
      res = Math.round(val * 100) / 100
      break
  }

  return res
}

export function handleColor(val) {
  let color = 't1'
  if (val === undefined) {
    return '--'
  }

  if (typeof val !== 'number') {
    val = parseFloat(val)
  }

  if (val > 0) {
    color = 'c1'
  } else if (val < 0) {
    color = 'c3'
  }

  return color
}
